import React from 'react';
import './project.css';

const ProjectCard = ({ project }) => {
  const { title, description, tags, image, url } = project;

  return (
    <article className="card">
      <div className="card__media">
        <img src={image} alt={title} onError={(e) => e.currentTarget.style.opacity = 0.6} />
      </div>
      <div className="card__body">
        <h3 className="card__title">{title}</h3>
        <p className="card__desc">{description}</p>
        <div className="card__tags">
          {tags.map((t) => (
            <span key={t} className="tag">{t}</span>
          ))}
        </div>
        <div className="card__actions">
          <a className="btn primary" href={url} target="_blank" rel="noreferrer">View</a>
        </div>
      </div>
    </article>
  );
};

export default ProjectCard;
